import { computed, defineComponent, onMounted, PropType, watch } from 'vue';
import { useStore } from 'vuex';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { ProjectAction, ProjectGetter } from '@/store/project/project.module';
import { Project } from '@/store/project/project.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import _ from 'lodash';

export default defineComponent({
  name: 'ResultProjectTypeComponent',
  components: {
    LoadingComponent
  },
  props: {
    fiscalYear: {
      type: Object as PropType<FiscalYear>
    },
    mode: {
      type: String,
      default: 'PROVINCE'
    },
    target: {
      type: Object,
    }
  },
  setup: (props) => {
    const store = useStore();
    const projects = computed<Project[]>(() => store.getters[ProjectGetter.ALL]);
    const isLoading = computed(() => store.getters[ProjectGetter.STATUS] === 'init' || store.getters[ProjectGetter.STATUS] === 'loading');

    interface ProjectTypeGroup {
      name: string;
      count: number;
      percent: number;
      budget: number;
    }
    const projectTypes = computed<ProjectTypeGroup[]>(() => {
      const grouped = groupingProjectByType(projects.value);
      const main = grouped.filter(m => m.percent > 20);

      if (main.length < grouped.length) {
        main.push({
          name: 'อื่นๆ',
          count: grouped.filter(m => m.percent <= 20).reduce((total, m) => total + m.count, 0),
          percent: grouped.filter(m => m.percent <= 20).reduce((total, m) => total + m.percent, 0),
          budget: grouped.filter(m => m.percent <= 20).reduce((total, m) => total + m.budget, 0),
        });
      }

      return main;
    });

    onMounted(() => {
      if (props.fiscalYear) {
        fetchProject(props.mode, props.fiscalYear?.id, props.target?.id);
      }
    });

    watch(() => [props.fiscalYear, props.target], ([fiscalYear, target]) => {
      fetchProject(props.mode, fiscalYear?.id, target?.id);
    });

    const fetchProject = (mode: string, fiscalYearId: number, targetId: number) => {
      switch (mode) {
        default:
          store.dispatch(ProjectAction.FETCH, {
            fiscalYearId: fiscalYearId,
            appointment: 'Admin',
            appointmentId: targetId
          });
          break;
        case 'MINISTER':
          store.dispatch(ProjectAction.FETCH, {
            fiscalYearId: fiscalYearId,
            appointment: 'Ministers',
            appointmentId: targetId
          });
          break;
        case 'REGION':
          store.dispatch(ProjectAction.FETCH, {
            fiscalYearId: fiscalYearId,
            appointment: 'Regions',
            appointmentId: targetId
          });
          break;
        case 'PROVINCE':
          store.dispatch(ProjectAction.FETCH, {
            fiscalYearId: props.fiscalYear?.id,
            appointment: 'Provinces',
            appointmentId:targetId
          });
          break;
      }
    };

    const groupingProjectByType = (projects: Project[]) => {
      return _.chain(projects)
        .filter(m => !m.isCanceled)
        .groupBy(m => m.projecType.name)
        .map((g, key) => ({
          name: key,
          count: g.length,
          percent: (g.length / projects.filter(x => !x.isCanceled).length) * 100,
          budget: g.reduce((total, x) => total + x.projectBudgets?.filter(z => z.id === 1).reduce((t, a) => t + a.amount, 0), 0)
        }))
        .value();
    };

    return {
      projectTypes,
      isLoading,
    };
  },
});
